import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router } from "react-router-dom";
import { Switch } from "react-router-dom";
import StickySidebar from "./layouts/StickySidebar";
import Dashboard from "./dashboard/MainDashboard";
import Login from "./authentication/Login";
import Profile from "./profile/Index";
import ProfileSettings from "./profile/ProfileSettings";

import ChangePassword from "./profile/ChangePassword";



import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import ForgotPassword from "./authentication/ForgotPassword";
import ResetPassword from "./authentication/ResetPassword";
import Logout from "./logout/Index";


import Employee from "./employees/Index";
import EmployeeAdd from "./employees/EmployeeAdd";
import EmployeeEdit from "./employees/EmployeeEdit";
import EmployeeView from "./employees/EmployeeView";

import CnssList from "./cnss/Index";
import EmployeeWorkTime from "./employeeworktime/Index";
import EmployeeWorkTimeDetails from "./employeeworktime/EmployeeWorkTimeDetails";
import EmployeePaySlip from "./employeeworktime/EmployeePaySlip";
import EmployeePaySlipAudit from "./employeeworktime/EmployeePaySlipAudit";

import EmployeeSetting from "./employeesetting/Index";
import EmployeeSettingAdd from "./employeesetting/EmployeeSettingAdd";
import EmployeeSettingEdit from "./employeesetting/EmployeeSettingEdit";

import Customers from "./customers/Index";
import AddCustomer from "./customers/AddCustomer";
import EditCustomer from "./customers/EditCustomer";
import ViewCustomer from "./customers/ViewCustomer";


import Products from "./products/Index";
import AddProduct from "./products/AddProduct";
import ProductListingGroupBY from "./products/ProductListingGroupBY"
import EditProduct from "./products/EditProduct";
import ViewProduct from "./products/ViewProduct";

import Farmers from "./farmers/Index";
import FarmerAdd from "./farmers/FarmerAdd";
import FarmerEdit from "./farmers/FarmerEdit";
import FarmerView from "./farmers/FarmerView";
import Locationtable from "./locations/Index";
import LocationtableAdd from "./locations/LocationtableAdd";
import LocationtableEdit from "./locations/LocationtableEdit";
import LocationView from "./locations/LocationView";
import SmallFarmers from "./smallfarms/Index";
import SmallFarmerAdd from "./smallfarms/SmallFarmerAdd";
import SmallFarmerEdit from "./smallfarms/SmallFarmerEdit";
import SmallFarmerView from "./smallfarms/SmallFarmerView";
import Quality from "./qualities/Index";
import QualityAdd from "./qualities/QualityAdd";
import QualityEdit from "./qualities/QualityEdit";
import QualityView from "./qualities/QualityView";

import QualityReports from "./qualityreports/Index";
import QualityReportsAdd from "./qualityreports/QualityReportsAdd";
import QualityReportsView from "./qualityreports/QualityReportsView";
import QualityReportsEdit from "./qualityreports/QualityReportsEdit";
import QualityReportsAddPallet from "./qualityreports/QualityReportsAddPallet";
import QualityReportPalletEdit from "./qualityreports/QualityReportPalletEdit";


import Orders from "./orders/Index";
import AddOrder from "./orders/AddOrder";
import EditOrder from "./orders/EditOrder";
import ViewOrder from "./orders/ViewOrder";

import Contracts from "./contracts/Index";
import Addcontract from "./contracts/Addcontract";
import Editcontract from "./contracts/Editcontract";
import Viewcontract from "./contracts/Viewcontract";

import ProductionDashboard from "./dashboard/ProductionDashboard";
import ProductionDashboardDailyReport from "./dashboard/ProductionDashboardDailyReport";


import ProductionOrders from "./productionorders/Index";
import ViewProductionOrders from "./productionorders/ViewOrder";
import ViewProductionOrdersPlannedDate from "./productionorders/ViewProductionOrdersPlannedDate";
import ProductionOrdersUpdatePlannedDate from "./productionorders/ProductionOrdersUpdatePlannedDate";

import RawMaterial from "./rawmaterial/Index";
import AddRawMaterial from "./rawmaterial/AddRawMaterial";
import EditRawMaterial from "./rawmaterial/EditRawMaterial";
import ViewRawMaterial from "./rawmaterial/ViewRawMaterial";
import ViewAllRawMaterialGroupBy from "./rawmaterial/ViewAllRawMaterialGroupBy";
import ViewAllRawMaterialGroupByLocation from "./rawmaterial/ViewAllRawMaterialGroupByLocation";

import ProductionOutput from "./productionoutput/Index";
import ProductionOutputAdd from "./productionoutput/ProductionOutputAdd";
import ProductionOutputAddEdit from "./productionoutput/ProductionOutputEdit";
import ViewProductionOutput from "./productionoutput/ViewProductionOutput";
import ViewProductionOutputGropyBy from "./productionoutput/ViewProductionOutputGropyBy";
import ViewProductionOutputGropyByPallet from "./productionoutput/ViewProductionOutputGropyByPallet";


import ProductionStocks from "./productiostocks/Index";
import ViewProductionStocks from "./productiostocks/ViewProductionStocks";

import RawMaterialPricing from "./rawmaterialpricing/Index";
import RawMaterialPricingEdit from "./rawmaterialpricing/RawMaterialPricingEdit";
import RawMaterialPricingView from "./rawmaterialpricing/RawMaterialPricingView";
import ViewAllRawMaterialPricingGroupBy from "./rawmaterialpricing/ViewAllRawMaterialPricingGroupBy";
import ViewAllRawMaterialPricingSupplierGroupBy from "./rawmaterialpricing/ViewAllRawMaterialPricingSupplierGroupBy";


import ProcurementList from "./procurementsupplier/ProcurementList";
import ProcurementSupplierAdd from "./procurementsupplier/ProcurementSupplierAdd";
import ProcurementSupplierEdit from "./procurementsupplier/ProcurementSupplierEdit";

import ProductionFeed from "./productionfeed/Index";
import ProductionFeedAdd from "./productionfeed/ProductionFeedAdd";
import ProductionFeedEdit from "./productionfeed/ProductionFeedEdit";
import ViewProductionFeed from "./productionfeed/ViewProductionFeed";
import ViewProductionFeedGropyBy from "./productionfeed/ViewProductionFeedGropyBy";

import Rmstock from "./rmstock/Index";
import RmstockAdd from "./rmstock/RmstockAdd";
import ViewRmstock from "./rmstock/ViewRmstock";
import ViewRmstockGropyBy from "./rmstock/ViewRmstockGropyBy";

import ProductionDailyReports from "./productiondailyreports/Index";
import ProductionDailyReportView from "./productiondailyreports/ProductionDailyReportView";


import SoldesSupplier from "./rawmaterialsoldessuppliers/SoldesSupplier";
// import SoldesSupplierGroupByView from "./rawmaterialsoldessuppliers/SoldesSupplierGroupByView";
import SupplierBalanceDetails from "./rawmaterialsoldessuppliers/SupplierBalanceDetails";


import Consumable from "./consumables/Index";
import ConsumableAdd from "./consumables/ConsumableAdd";
import ConsumableEdit from "./consumables/ConsumableEdit";
import ConsumableView from "./consumables/ConsumableView";

import Supplier from "./suppliers/Index";
import SupplierAdd from "./suppliers/SupplierAdd";
import SupplierEdit from "./suppliers/SupplierEdit";
import SupplierView from "./suppliers/SupplierView";


import SupplyChainLoading from "./supplychainloading/Index";
import AddSupplyChainLoading from "./supplychainloading/AddSupplyChainLoading";
import EditSupplyChainLoading from "./supplychainloading/EditSupplyChainLoading";
import ViewSupplyChainLoading from "./supplychainloading/ViewSupplyChainLoading";

import SupplyChainOrders from "./supplychainorders/Index";
import ViewSupplyChainOrders from "./supplychainorders/ViewOrder";

import StockFollowUp from "./stockfollowups/Index";
import StockFollowUpAdd from "./stockfollowups/StockFollowUpAdd";
import StockFollowUpEdit from "./stockfollowups/StockFollowUpEdit";
import StockFollowUpView from "./stockfollowups/StockFollowUpView";
import StockFollowUpViewByConsumble from "./stockfollowups/StockFollowUpViewByConsumble";
import StockFollowUpViewByLocationDate from "./stockfollowups/StockFollowUpViewByLocationDate";
import StockFollowUpViewByConsumableLocation from "./stockfollowups/StockFollowUpViewByConsumableLocation";
import StockFollowUpViewBySupplierLocation from "./stockfollowups/StockFollowUpViewBySupplierLocation";




import StockInventory from "./stockinventories/Index";
import StockInventoryAdd from "./stockinventories/StockInventoryAdd";
import StockInventoryEdit from "./stockinventories/StockInventoryEdit";
import StockInventoryGroupByDateLocation from "./stockinventories/StockInventoryGroupByDateLocation";



import SupplychainPackagelistHeaders from "./supplychainpackagelistheaders/Index";
import SupplychainPackagelistHeadersAdd from "./supplychainpackagelistheaders/SupplychainPackagelistHeadersAdd";
import SupplychainPackagelistHeadersView from "./supplychainpackagelistheaders/SupplychainPackagelistHeadersView";
import SupplychainPackagelistHeadersEdit from "./supplychainpackagelistheaders/SupplychainPackagelistHeadersEdit";

import Expenses from "./expenses/Index";
import ExpenseAdd from "./expenses/ExpenseAdd";
import ExpenseEdit from "./expenses/ExpenseEdit";
import ExpenseView from "./expenses/ExpenseView"

import FinanceSupplier from "./financessuppliers/Index";
import FinanceSupplierAdd from "./financessuppliers/FinanceSupplierAdd";
import FinanceSupplierEdit from "./financessuppliers/FinanceSupplierEdit";
import Supplierssituation from "./supplierssituation/Index";
import SupplierssituationDetails from "./supplierssituation/SupplierssituationDetails";

import CaisseEspace from "./caisseespace/Index";
import CaisseEspaceAdd from "./caisseespace/CaisseEspaceAdd";
import CaisseEspaceEdit from "./caisseespace/CaisseEspaceEdit";

import CaisseBank from "./caissebank/Index";
import CaisseBankAdd from "./caissebank/CaisseBankAdd";
import CaisseBankEdit from "./caissebank/CaisseBankEdit";

import ChequeFollowUp from "./chequefollowups/Index";
import ChequeFollowUpAdd from "./chequefollowups/ChequeFollowUpAdd";
import ChequeFollowUpEdit from "./chequefollowups/ChequeFollowUpEdit";


import BankAccountTransaction from "./bankaccounttransaction/Index";
import BankAccountTransactionAdd from "./bankaccounttransaction/BankAccountTransactionAdd";
import BankAccountTransactionEdit from "./bankaccounttransaction/BankAccountTransactionEdit";
import BankAccountTransactionView from "./bankaccounttransaction/BankAccountTransactionView"


import InvoicingCustomerBalance from "./customerbalance/InvoicingCustomerBalance";
import InvoicingCustomerBalanceDetails from "./customerbalance/InvoicingCustomerBalanceDetails";
import InvoicingCustomerBalanceDetailsDashbaord from "./customerbalance/InvoicingCustomerBalanceDetailsDashbaord";


import InvoicingHeaders from "./invoicingheaders/Index";
import AddInvoicingHeaders from "./invoicingheaders/AddInvoice";
import ViewInvoice from "./invoicingheaders/ViewInvoice";
import EditInvoicingHeaders from "./invoicingheaders/EditInvoice";
import EditInvoicingPayment from "./invoicingheaders/EditInvoicingPayment";
import EditInvoicingPaymentAdd from "./invoicingheaders/EditInvoicingPaymentAdd";
import EditInvoicePayment from "./invoicingheaders/EditInvoicePayment";


import Users from "./users/Index";
import AddUser from "./users/AddUser";
import EditUser from "./users/EditUser";
import ViewUser from "./users/ViewUser";
import PaymentsTerm from "./paymentterms/Index";
import PaymentsTermAdd from "./paymentterms/PaymentsTermAdd";
import PaymentsTermEdit from "./paymentterms/PaymentsTermEdit";

import Season from "./seasons/Index";
import SeasonAdd from "./seasons/SeasonAdd";
import SeasonEdit from "./seasons/SeasonEdit";


import CalledCantacts from "./calledcontacts/Index";
import AddCalledCantacts from "./calledcontacts/AddCalledCantacts";
import EditCalledCantacts from "./calledcontacts/EditCalledCantacts";
import CustomerForgotPassword from "./customer_role/CustomerForgotPassword";

import CustomerResetPassword from "./customer_role/CustomerResetPassword";


import CustomerDashboard from "./customer_role/CustomerDashboard";
import CustomerOrders from "./customer_role/CustomerOrders";
import CustomerOrdersView from "./customer_role/CustomerOrdersView";

import CustomerPackagingSites from "./customer_role/CustomerPackagingSites";
import CustomerPackagingSitesView from "./customer_role/CustomerPackagingSitesView";

import CustomerFarms from "./customer_role/CustomerFarms";
import CustomerFarmsView from "./customer_role/CustomerFarmsView";


import CustomerQualityReports from "./customer_role/CustomerQualityReports";
import CustomerQualityReportsView from "./customer_role/CustomerQualityReportsView";

import CustomerInvoicePayment from "./customer_role/CustomerInvoicePayment";
import CustomerInvoicePaymentDetails from "./customer_role/CustomerInvoicePaymentDetails";
import CustomerInvoiceAllPaymentDetails from "./customer_role/CustomerInvoiceAllPaymentDetails";


import CustomerLoadingView from "./customer_role/CustomerLoadingView";
import CustomerLoading from "./customer_role/CustomerLoading";
import CustomerContacts from "./customer_role/CustomerContacts";
import CustomerProducts from "./customer_role/CustomerProducts";
import CustomerProductView from "./customer_role/CustomerProductView";



import CustomerLogin from "./customer_role/CustomerLogin";
import CustomerLogout from "./customer_role/CustomerLogout";

import CustomerProfile from "./customer_role/CustomerProfile";

import CustomerProfileSettings from "./customer_role/CustomerProfileSettings";
import CustomerChangePassword from "./customer_role/CustomerChangePassword";
import CustomerUsers from "./customer_role/CustomerUsers";
import CustomerUsersEdit from "./customer_role/CustomerUsersEdit";
import CustomerUsersAdd from "./customer_role/CustomerUsersAdd";



import QualityConsumable from "./qualityconsumables/Index";
import QualityConsumableAdd from "./qualityconsumables/QualityConsumableAdd";
import QualityConsumableEdit from "./qualityconsumables/QualityConsumableEdit";
import QualityConsumableView from "./qualityconsumables/QualityConsumableView";


import QualityStockFollowUp from "./qualityStockfollowups/Index";
import QualityStockFollowUpAdd from "./qualityStockfollowups/QualityStockFollowUpAdd";
import QualityStockFollowUpEdit from "./qualityStockfollowups/QualityStockFollowUpEdit";
import QualityStockFollowUpView from "./qualityStockfollowups/QualityStockFollowUpView";
import QualityStockFollowUpViewByConsumble from "./qualityStockfollowups/QualityStockFollowUpViewByConsumble";
import QualityStockFollowUpViewByLocationDate from "./qualityStockfollowups/QualityStockFollowUpViewByLocationDate";
import QualityStockFollowUpViewByConsumableLocation from "./qualityStockfollowups/QualityStockFollowUpViewByConsumableLocation";
import QualityStockFollowUpViewBySupplierLocation from "./qualityStockfollowups/QualityStockFollowUpViewBySupplierLocation";


const AppContainer = () => {
  // const config = "/template/react";
  const [showStickySidebar, setShowStickySidebar] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Hide the sidebar on the "/invoices" page
    setShowStickySidebar(
      location.pathname !== "/invoice-one-a" &&
      location.pathname !== "/invoice-two" &&
      location.pathname !== "/invoice-three" &&
      location.pathname !== "/invoice-four-a" &&
      location.pathname !== "/invoice-five" &&
      location.pathname !== "/cashreceipt-1" &&
      location.pathname !== "/cashreceipt-2" &&
      location.pathname !== "/cashreceipt-3" &&
      location.pathname !== "/cashreceipt-4"
    );
  }, [location.pathname]);

  return (
    <Router basename="/">
      {showStickySidebar && <StickySidebar />}
      <Switch>

        <Route path="/logout" component={Logout} />
        <Route path="/index" component={Dashboard} />
        <Route path="/profile" component={Profile} />
        <Route path="/update-profile" component={ProfileSettings} />

        <Route path="/change-password" component={ChangePassword} />
        <Route path="/login" exact component={Login} />

        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password/:token" component={ResetPassword} />

        <Route path="/employees" component={Employee} />
        <Route path="/employees-add" component={EmployeeAdd} />
        <Route path="/employees-edit/:id" component={EmployeeEdit} />
        <Route path="/employees-view/:id" component={EmployeeView} />


        <Route path="/work-time-tracking" component={EmployeeWorkTime} />
        <Route path="/work-time-tracking-view-all/:id" component={EmployeeWorkTimeDetails} />
        <Route path="/cnss" component={CnssList} />


        <Route path="/pay-slip" component={EmployeePaySlip} />

        <Route path="/payslip-audit" component={EmployeePaySlipAudit} />

        <Route path="/employee-setting" component={EmployeeSetting} />
        <Route path="/employee-setting-add" component={EmployeeSettingAdd} />
        <Route path="/employee-setting-edit/:id" component={EmployeeSettingEdit} />



        <Route path="/quality-consumables" component={QualityConsumable} />
        <Route path="/quality-consumables-add" component={QualityConsumableAdd} />
        <Route path="/quality-consumables-edit/:id" component={QualityConsumableEdit} />
        <Route path="/quality-consumables-view/:id" component={QualityConsumableView} />

        <Route path="/quality-stock-situations" component={QualityStockFollowUp} />
        <Route path="/quality-stock-situations-add" component={QualityStockFollowUpAdd} />
        <Route path="/quality-stock-situations-edit/:id" component={QualityStockFollowUpEdit} />
        <Route path="/quality-stock-situations-view/:id" component={QualityStockFollowUpView} />
        <Route path="/quality-stock-situations-viewby-consumable/:id" component={QualityStockFollowUpViewByConsumble} />
        <Route path="/quality-stock-situations-viewby-location-date/:id" component={QualityStockFollowUpViewByLocationDate} />
        <Route path="/quality-stock-situations-viewby-consumable-location/:id" component={QualityStockFollowUpViewByConsumableLocation} />
        <Route path="/quality-stock-situations-viewby-consumable-section-location/:id" component={QualityStockFollowUpViewBySupplierLocation} />


        <Route path="/customers" component={Customers} />
        <Route path="/customers-add" component={AddCustomer} />
        <Route path="/customers-edit/:id" component={EditCustomer} />
        <Route path="/customers-view/:id" component={ViewCustomer} />

        <Route path="/products" component={Products} />
        <Route path="/products-add" component={AddProduct} />
        <Route path="/products-edit/:id" component={EditProduct} />
        <Route path="/products-groupby-name/:id" component={ProductListingGroupBY} />
        <Route path="/products-view/:id" component={ViewProduct} />

        <Route path="/orders" component={Orders} />
        <Route path="/orders-add" component={AddOrder} />
        <Route path="/orders-edit/:id" component={EditOrder} />
        <Route path="/orders-view/:id" component={ViewOrder} />

        <Route path="/contracts" component={Contracts} />
        <Route path="/contracts-add" component={Addcontract} />
        <Route path="/contracts-edit/:id" component={Editcontract} />
        <Route path="/contracts-view/:id" component={Viewcontract} />


        <Route path="/farms" component={Farmers} />
        <Route path="/farms-add" component={FarmerAdd} />
        <Route path="/farms-edit/:id" component={FarmerEdit} />
        <Route path="/farms-view/:id" component={FarmerView} />

        <Route path="/locations" component={Locationtable} />
        <Route path="/locations-add" component={LocationtableAdd} />
        <Route path="/locations-edit/:id" component={LocationtableEdit} />
        <Route path="/locations-view/:id" component={LocationView} />

        <Route path="/small-farms" component={SmallFarmers} />
        <Route path="/small-farms-add" component={SmallFarmerAdd} />
        <Route path="/small-farms-edit/:id" component={SmallFarmerEdit} />
        <Route path="/small-farms-view/:id" component={SmallFarmerView} />

        <Route path="/qualities" component={Quality} />
        <Route path="/qualities-add" component={QualityAdd} />
        <Route path="/qualities-edit/:id" component={QualityEdit} />
        <Route path="/qualities-view/:id" component={QualityView} />

        <Route path="/quality-reports" component={QualityReports} />
        <Route path="/quality-reports-add" component={QualityReportsAdd} />
        <Route path="/quality-reports-view/:id" component={QualityReportsView} />
        <Route path="/quality-reports-edit/:id" component={QualityReportsEdit} />
        <Route path="/quality-reports-addpallet/:id" component={QualityReportsAddPallet} />
        <Route path="/quality-reports-editpallet/:id" component={QualityReportPalletEdit} />

        <Route path="/production-dasboard" component={ProductionDashboard} />

        <Route path="/production-dasboard-dailyreports/:id" component={ProductionDashboardDailyReport} />
        <Route path="/production-orders" component={ProductionOrders} />
        <Route path="/production-orders-view/:id" component={ViewProductionOrders} />

        <Route path="/production-orders-planned-date/:id" component={ViewProductionOrdersPlannedDate} />
        <Route path="/production-orders-update-production-date/:id" component={ProductionOrdersUpdatePlannedDate} />

        <Route path="/raw-materials" component={RawMaterial} />
        <Route path="/raw-materials-add" component={AddRawMaterial} />
        <Route path="/raw-materials-edit/:id" component={EditRawMaterial} />
        <Route path="/raw-materials-view/:id" component={ViewRawMaterial} />
        <Route path="/raw-materials-groupby/:id" component={ViewAllRawMaterialGroupBy} />
        <Route path="/raw-materials-groupbylocation/:id" component={ViewAllRawMaterialGroupByLocation} />

        <Route path="/production-output" component={ProductionOutput} />
        <Route path="/production-output-add" component={ProductionOutputAdd} />
        <Route path="/production-output-edit/:id" component={ProductionOutputAddEdit} />
        <Route path="/production-output-view/:id" component={ViewProductionOutput} />
        <Route path="/production-output-groupby/:id" component={ViewProductionOutputGropyBy} />
        <Route path="/production-output-pallettype/:id" component={ViewProductionOutputGropyByPallet} />


        <Route path="/production-stocks" component={ProductionStocks} />
        <Route path="/production-stocks-view/:id" component={ViewProductionStocks} />



        <Route path="/raw-material-pricing" component={RawMaterialPricing} />
        <Route path="/raw-material-pricing-edit/:id" component={RawMaterialPricingEdit} />
        <Route path="/raw-material-pricing-view/:id" component={RawMaterialPricingView} />
        <Route path="/raw-material-pricing-groupby/:id" component={ViewAllRawMaterialPricingGroupBy} />
        <Route path="/raw-material-pricing-supplier-groupby/:id" component={ViewAllRawMaterialPricingSupplierGroupBy} />



        <Route path="/production-feeds" component={ProductionFeed} />
        <Route path="/production-feeds-add" component={ProductionFeedAdd} />
        <Route path="/production-feeds-edit/:id" component={ProductionFeedEdit} />
        <Route path="/production-feeds-view/:id" component={ViewProductionFeed} />
        <Route path="/production-feeds-groupby/:id" component={ViewProductionFeedGropyBy} />



        <Route path="/rm-stock" component={Rmstock} />
        <Route path="/rm-stock-add" component={RmstockAdd} />
        <Route path="/rm-stock-view/:id" component={ViewRmstock} />
        <Route path="/rm-stock-groupby/:id" component={ViewRmstockGropyBy} />

        <Route path="/dailyreports" component={ProductionDailyReports} />
        <Route path="/dailyreports-view/:id" component={ProductionDailyReportView} />



        <Route path="/procurementsuppliers" component={ProcurementList} />
        <Route path="/procurementsuppliers-add" component={ProcurementSupplierAdd} />
        <Route path="/procurementsuppliers-edit/:id" component={ProcurementSupplierEdit} />

        <Route path="/supplier-balances" component={SoldesSupplier} />
        {/* <Route path="/supplier-balances-groupby/:id" component={SoldesSupplierGroupByView} /> */}
        <Route path="/supplier-balances-detail/:id" component={SupplierBalanceDetails} />

        <Route path="/consumables" component={Consumable} />
        <Route path="/consumables-add" component={ConsumableAdd} />
        <Route path="/consumables-edit/:id" component={ConsumableEdit} />
        <Route path="/consumables-view/:id" component={ConsumableView} />

        <Route path="/suppliers" component={Supplier} />
        <Route path="/suppliers-add" component={SupplierAdd} />
        <Route path="/suppliers-edit/:id" component={SupplierEdit} />
        <Route path="/suppliers-view/:id" component={SupplierView} />

        <Route path="/supplychain-loadings" component={SupplyChainLoading} />
        <Route path="/supplychain-loadings-add" component={AddSupplyChainLoading} />
        <Route path="/supplychain-loadings-edit/:id" component={EditSupplyChainLoading} />
        <Route path="/supplychain-loadings-view/:id" component={ViewSupplyChainLoading} />

        <Route path="/supplychainorders" component={SupplyChainOrders} />
        <Route path="/supplychainorders-view/:id" component={ViewSupplyChainOrders} />

        <Route path="/supplychain-package-lists" component={SupplychainPackagelistHeaders} />
        <Route path="/supplychain-package-lists-add" component={SupplychainPackagelistHeadersAdd} />
        <Route path="/supplychain-package-lists-view/:id" component={SupplychainPackagelistHeadersView} />
        <Route path="/supplychain-package-lists-edit/:id" component={SupplychainPackagelistHeadersEdit} />


        <Route path="/stock-situations" component={StockFollowUp} />
        <Route path="/stock-situations-add" component={StockFollowUpAdd} />
        <Route path="/stock-situations-edit/:id" component={StockFollowUpEdit} />
        <Route path="/stock-situations-view/:id" component={StockFollowUpView} />
        <Route path="/stock-situations-viewby-consumable/:id" component={StockFollowUpViewByConsumble} />

        <Route path="/stock-situations-viewby-location-date/:id" component={StockFollowUpViewByLocationDate} />
        <Route path="/stock-situations-viewby-consumable-location/:id" component={StockFollowUpViewByConsumableLocation} />
        <Route path="/stock-situations-viewby-supplier-location/:id" component={StockFollowUpViewBySupplierLocation} />

        <Route path="/stock-inventories" component={StockInventory} />
        <Route path="/stock-inventories-add" component={StockInventoryAdd} />
        <Route path="/stock-inventories-edit/:id" component={StockInventoryEdit} />
        <Route path="/stock-inventories-groupby-location-date/:id" component={StockInventoryGroupByDateLocation} />







        <Route path="/expenses" component={Expenses} />
        <Route path="/expenses-add" component={ExpenseAdd} />
        <Route path="/expenses-edit/:id" component={ExpenseEdit} />
        <Route path="/expenses-view/:id" component={ExpenseView} />

        <Route path="/financessuppliers" component={FinanceSupplier} />
        <Route path="/financessuppliers-add" component={FinanceSupplierAdd} />
        <Route path="/financessuppliers-edit/:id" component={FinanceSupplierEdit} />

        <Route path="/financesuppliersituation" component={Supplierssituation} />
        <Route path="/financesuppliersituation-detail/:id" component={SupplierssituationDetails} />

        <Route path="/caisse-espece" component={CaisseEspace} />
        <Route path="/caisse-espece-add" component={CaisseEspaceAdd} />
        <Route path="/caisse-espece-edit/:id" component={CaisseEspaceEdit} />

        <Route path="/caisse-bank" component={CaisseBank} />
        <Route path="/caisse-bank-add" component={CaisseBankAdd} />
        <Route path="/caisse-bank-edit/:id" component={CaisseBankEdit} />

        <Route path="/cheque-follow-ups" component={ChequeFollowUp} />
        <Route path="/cheque-follow-ups-add" component={ChequeFollowUpAdd} />
        <Route path="/cheque-follow-ups-edit/:id" component={ChequeFollowUpEdit} />

        <Route path="/bank-account-transactions" component={BankAccountTransaction} />
        <Route path="/bank-account-transactions-add" component={BankAccountTransactionAdd} />
        <Route path="/bank-account-transactions-edit/:id" component={BankAccountTransactionEdit} />
        <Route path="/bank-account-transactions-view/:id" component={BankAccountTransactionView} />

        <Route path="/customer-balances" component={InvoicingCustomerBalance} />
        <Route path="/customer-balances-details/:id" component={InvoicingCustomerBalanceDetails} />
        <Route path="/customer-balances-details-customerdasboard/:id" component={InvoicingCustomerBalanceDetailsDashbaord} />


        <Route path="/invoices" component={InvoicingHeaders} />
        <Route path="/invoices-add" component={AddInvoicingHeaders} />
        <Route path="/invoices-view/:id" component={ViewInvoice} />
        <Route path="/invoices-edit/:id" component={EditInvoicingHeaders} />
        <Route path="/invoices-payment/:id" component={EditInvoicingPayment} />
        <Route path="/invoices-payment-add/:id" component={EditInvoicingPaymentAdd} />

        <Route path="/invoices-payment-edit/:id" component={EditInvoicePayment} />


        <Route path="/users" component={Users} />
        <Route path="/users-add" component={AddUser} />
        <Route path="/users-edit/:id" component={EditUser} />
        <Route path="/users-view/:id" component={ViewUser} />

        <Route path="/payment-terms" component={PaymentsTerm} />
        <Route path="/payment-terms-add" component={PaymentsTermAdd} />
        <Route path="/payment-terms-edit/:id" component={PaymentsTermEdit} />

        <Route path="/called-contacts" component={CalledCantacts} />
        <Route path="/called-contacts-add" component={AddCalledCantacts} />

        <Route path="/called-contacts-edit/:id" component={EditCalledCantacts} />

        <Route path="/seasons" component={Season} />
        <Route path="/seasons-add" component={SeasonAdd} />
        <Route path="/seasons-edit/:id" component={SeasonEdit} />


        {/* Customer Routes Start */}



        <Route path="/customerportal/login" component={CustomerLogin} />
        <Route path="/customerportal/logout" component={CustomerLogout} />

        <Route path="/customerportal/profile" component={CustomerProfile} />
        <Route path="/customerportal/users" component={CustomerUsers} />
        <Route path="/customerportal/users-add" component={CustomerUsersAdd} />
        <Route path="/customerportal/users-edit/:id" component={CustomerUsersEdit} />

        <Route path="/customerportal/update-profile" component={CustomerProfileSettings} />
        <Route path="/customerportal/change-password" component={CustomerChangePassword} />

        <Route path="/customerportal/forgot-password" component={CustomerForgotPassword} />
        <Route path="/customerportal/reset-password/:token" component={CustomerResetPassword} />

        <Route path="/customerportal/index" component={CustomerDashboard} />
        <Route path="/customerportal/orders" component={CustomerOrders} />
        <Route path="/customerportal/orders-view/:id" component={CustomerOrdersView} />

        <Route path="/customerportal/packing-sites" component={CustomerPackagingSites} />
        <Route path="/customerportal/packing-sites-view/:id" component={CustomerPackagingSitesView} />

        <Route path="/customerportal/farms" component={CustomerFarms} />
        <Route path="/customerportal/farms-view/:id" component={CustomerFarmsView} />


        <Route path="/customerportal/quality-reports" component={CustomerQualityReports} />
        <Route path="/customerportal/quality-reports-view/:id" component={CustomerQualityReportsView} />


        <Route path="/customerportal/invoices-payments" component={CustomerInvoicePayment} />
        <Route path="/customerportal/invoices-payments-view/:id" component={CustomerInvoicePaymentDetails} />
        <Route path="/customerportal/invoices-payments-all-view/:id" component={CustomerInvoiceAllPaymentDetails} />


        <Route path="/customerportal/loadings" component={CustomerLoading} />
        <Route path="/customerportal/loadings-view/:id" component={CustomerLoadingView} />
        <Route path="/customerportal/contacts" component={CustomerContacts} />
        <Route path="/customerportal/products" component={CustomerProducts} />
        <Route path="/customerportal/products-view/:id" component={CustomerProductView} />






        {/* Customer Routes End */}

      </Switch>
    </Router>
  );
};

export default AppContainer;
